import React, { FC } from 'react';
import { View, Text } from 'react-native';
import { UseTableColumnsParams } from '@v2/pages/common/components/NCFileBatchEvents/types';
import { font as initialFont } from '@styles/fonts';
import { EventStatusSubStatusExecModeProps } from '@v2/pages/common/components/NCFileBatchEvents/components/EventStatusSubStatusExecMode';

export interface NCFileNameCellProps extends Pick<UseTableColumnsParams, 'C' | 'font'>, Pick<EventStatusSubStatusExecModeProps, 'event'> {}

const NCFileNameCell: FC<NCFileNameCellProps> = ({ event, C, font = initialFont }) => {
  return (
    <View style={{ width: '100%' }}>
      <Text numberOfLines={1} ellipsizeMode="tail" style={[font['Subhead 2'], { color: C('Label/Light/Primary') }]}>
        {event?.ncFileName}
      </Text>
    </View>
  );
};

export default React.memo(NCFileNameCell, (prev, next) => {
  return prev.event.ncFileName === next.event.ncFileName && prev.C.scheme === next.C.scheme;
});
